const algoliasearch = require("algoliasearch");

let client = algoliasearch(
  process.env.REACT_APP_ALGOLIA_APP_ID,
  process.env.REACT_APP_ALGOLIA_API_KEY
);

export const challengesIndex = client.initIndex(
  process.env.REACT_APP_ALGOLIA_CHALLENGES_INDEX
);

export const companiesIndex = client.initIndex(
  process.env.REACT_APP_ALGOLIA_COMPANIES_INDEX
);

export const profilesIndex = client.initIndex(
  process.env.REACT_APP_ALGOLIA_PROFILES_INDEX
);

export const clientsIndex = client.initIndex(
  process.env.REACT_APP_ALGOLIA_CLIENT_INDEX
);



// WEBPACK FOOTER //
// ./src/utils/algolia.js